export default __webpack_public_path__ + "static/Klick-Bold-aa5297c946d25968b174d9cae04eca7f.woff";